import { ValidationMode } from 'react-hook-form';

export const valdationOpts = {
  shouldFocusError: true,
  mode: 'onChange' as ValidationMode['all'],
};
